// extracted by mini-css-extract-plugin
module.exports = {"container":"ClosedAsset_container__1BST0"};